'use es6';

import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled, { css } from 'styled-components';
import PriceDisplay from 'pricing-pages-unified-ui/components/common/pricing/PriceDisplay';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import Small from 'UIComponents/elements/Small';
import { useSelector } from 'react-redux';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { MONTHLY } from 'self-service-api/constants/Terms';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
import H3 from 'UIComponents/elements/headings/H3';
import { isEligibleForLatamPromotionSelector, isEligibleForRetailPromotionSelector } from '../../../selectors/PromotionSelectors';
const fullPriceStyles = css(["line-height:initial;padding:1px 0 2px 8px;display:block;"]);
export const FullPriceContainerBlock = styled.div.withConfig({
  displayName: "HighlightedPriceDisplay__FullPriceContainerBlock",
  componentId: "sc-3bzgvf-0"
})(["font-size:20px;font-weight:500;", ""], fullPriceStyles);
export const FullPriceContainerBlockLarge = styled(H3).withConfig({
  displayName: "HighlightedPriceDisplay__FullPriceContainerBlockLarge",
  componentId: "sc-3bzgvf-1"
})(["margin-bottom:0;", ""], fullPriceStyles);
export const PriceContainer = styled.div.withConfig({
  displayName: "HighlightedPriceDisplay__PriceContainer",
  componentId: "sc-3bzgvf-2"
})(["line-height:initial;"]);
export const CrossedOutPrice = styled(PriceDisplay).withConfig({
  displayName: "HighlightedPriceDisplay__CrossedOutPrice",
  componentId: "sc-3bzgvf-3"
})(["text-decoration:line-through;"]);
export const CrossedOutSubtextPrice = styled(PriceDisplay).withConfig({
  displayName: "HighlightedPriceDisplay__CrossedOutSubtextPrice",
  componentId: "sc-3bzgvf-4"
})(["text-decoration:line-through;"]);
export const PriceSection = styled.div.withConfig({
  displayName: "HighlightedPriceDisplay__PriceSection",
  componentId: "sc-3bzgvf-5"
})(["text-align:right;"]);
export const MicroCopy = styled(Small).withConfig({
  displayName: "HighlightedPriceDisplay__MicroCopy",
  componentId: "sc-3bzgvf-6"
})(["display:block;", ""], breakpoint.tablet(_t || (_t = _`
    display: inline;
  `)));
export const Bold = styled.span.withConfig({
  displayName: "HighlightedPriceDisplay__Bold",
  componentId: "sc-3bzgvf-7"
})(["font-weight:600;"]);
export const PerMonth = styled.span.withConfig({
  displayName: "HighlightedPriceDisplay__PerMonth",
  componentId: "sc-3bzgvf-8"
})(["font-weight:500;"]);
export const HighlightedPriceDisplay = ({
  pricingInfo,
  skuId,
  nonMerchandiseIdProduct,
  wrapperStyle,
  useLargePrice,
  showingOnlyAdditionalCost
}) => {
  const showRetailStarterPrice = useSelector(state => skuId && isEligibleForRetailPromotionSelector(state, {
    skuId
  }));
  const currencyCode = useSelector(activeCurrencySelector);
  const {
    monthly: {
      fullPrice: monthlyFullPrice,
      calculatedPrice: monthlyCalculatedPrice
    },
    annually: {
      fullPrice: annualFullPrice,
      calculatedPrice: annualCalculatedPrice
    },
    offerInfo
  } = pricingInfo; // Temporary solution - only show for latam

  const showCrossedOutMonthlyFullPrice = useSelector(state => skuId && isEligibleForLatamPromotionSelector(state, {
    skuId
  }));
  const discountedKey = offerInfo.payment === MONTHLY ? showCrossedOutMonthlyFullPrice ? 'promotionPricingPerMonthBilledMonthly_jsx' : 'discountedPricingPerMonthBilledMonthly_jsx' : showCrossedOutMonthlyFullPrice ? 'promotionPricingPerYearAtCost_jsx' : 'discountedPricingPerYearAtCost_jsx';
  const normalKey = offerInfo.payment === MONTHLY ? showingOnlyAdditionalCost ? 'additionalCostPerMonthBilledMonthly_jsx' : 'pricingPerMonthBilledMonthly_jsx' : showingOnlyAdditionalCost ? 'additionalCostPerMonthBilledYearly_jsx' : 'pricingPerYearAtCost_jsx';
  const shouldCheckOfferInfoForDiscount = !!skuId && !showRetailStarterPrice;
  const showDiscountedCopy = !showingOnlyAdditionalCost && (shouldCheckOfferInfoForDiscount ? offerInfo.discount > 0 : monthlyFullPrice > monthlyCalculatedPrice); // Temporary for CRM suite where we override the price object

  const apiName = useSelector(state => {
    const product = skuId && productForSkuIdSelector(state, {
      skuId
    });
    return product && product.apiName;
  });
  const seleniumId = apiName || nonMerchandiseIdProduct || 'loading';
  return /*#__PURE__*/_jsx(PriceSection, {
    style: wrapperStyle,
    children: showDiscountedCopy ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `pricingPage.${discountedKey}`,
      options: {
        currencyCode,
        monthlyFullPrice,
        monthlyDiscountedPrice: monthlyCalculatedPrice,
        seleniumId,
        annualFullPrice,
        annualDiscountedPrice: annualCalculatedPrice
      },
      elements: {
        MicroCopy,
        FullPriceContainer: useLargePrice ? FullPriceContainerBlockLarge : FullPriceContainerBlock,
        CrossedOutSubtextPrice,
        PriceDisplay,
        Bold,
        PriceContainer,
        PerMonth
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `pricingPage.${normalKey}`,
      options: {
        currencyCode,
        price: monthlyCalculatedPrice,
        annualPrice: annualCalculatedPrice,
        seleniumId
      },
      elements: {
        MicroCopy,
        PriceContainer: useLargePrice ? FullPriceContainerBlockLarge : FullPriceContainerBlock,
        PriceDisplay,
        Bold,
        PerMonth
      }
    })
  });
};